export const IP_LOCATION = "https://ipapi.co/json";
